import { useCallback, useEffect, useState } from 'react';
import { api, errorText } from './client';

export interface ApiResource<T> {
  data: T | null;
  error: string | null;
  loading: boolean;
  reload(): Promise<void>;
}

/** Carrega um recurso GET da API e permite recarregar depois de uma alteração. */
export function useApi<T>(path: string | null, refreshMs?: number): ApiResource<T> {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(path !== null);

  const reload = useCallback(async () => {
    if (!path) return;
    try {
      setData(await api.get<T>(path));
      setError(null);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setLoading(false);
    }
  }, [path]);

  useEffect(() => {
    setData(null);
    setError(null);
    setLoading(path !== null);
    void reload();
    if (!refreshMs) return;
    const timer = setInterval(() => void reload(), refreshMs);
    return () => clearInterval(timer);
  }, [reload, path, refreshMs]);

  return { data, error, loading, reload };
}
